import React from "react";

import ErrorMessage from "./ErrorMessage";

export default function NotFound() {
  return (
    <main className="my-5 container">
      <ErrorMessage
        errorMessage={"Sorry, we couldn't find the page you were looking for."}
      />
    </main>
  );
}
